// import './registerServiceWorker';
import App from './App.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import store from './store';
import Vue from 'vue';
import VueGtag from 'vue-gtag';
import vuetify from './plugins/vuetify';
import { api, authTokenStore } from '@/services/api';
import { createRouter } from './router';
import { loadUserFromStoredToken } from '@antriver/vue-site-utils/src/util/auth';
import { pluralize } from '@antriver/vue-site-utils/src/filters';
import { round } from '@/filters/round';
import cfg from '@/config';

Vue.config.productionTip = false;

Vue.component('ErrorMessage', ErrorMessage);
Vue.component('LoadingSpinner', LoadingSpinner);

Vue.filter('pluralize', pluralize);
Vue.filter('round', round);

Vue.use(VueGtag, {
    config: { id: cfg.googleAnalyticsId },
});

// Check if already logged in.
if (authTokenStore.getToken()) {
    (window as any).existingAuthPromise = loadUserFromStoredToken(
        authTokenStore,
        store,
        api,
    );
    (window as any).existingAuthPromise.finally(() => {
        (window as any).existingAuthPromise = null;
    });
}

const router = createRouter(store);

const rootVue = new Vue({
    // @ts-ignore
    api,
    router,
    store,
    vuetify,
    render: (h) => h(App),
});
// For debugging in console.
(window as any).rootVue = rootVue;

rootVue.$mount('#app');
